var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","height":"60"}},[_c('v-spacer'),_vm._v("\n  "+_vm._s(_vm.name)+"\n  "),(_vm.isAuthenticated)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.logout}},[_vm._v("Salir")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }